import React, { useState } from 'react'
import { Button } from '@/components/atoms/button'
import { Typography } from '@/components/atoms/typography'
import type { CreditSheetProps } from './credit-sheet.types'
import { Sheet } from '@/components/organisms/sheet'
import { RequestCreditsDialog } from '../request-credits-view/component/request-credit-dialog'

export const CreditSheet: React.FC<CreditSheetProps> = ({
  open,
  onClose,
  credit_details = '0',
  description,
  onRequestCredits,
  onProceedToPayment,
  trigger = null,
  containerId,
  className,
  dialogClassName,
  buyCreditsOptions,
  minimumCreditsToBuy,
  requestOnly,
}) => {
  const [showRequestDialog, setShowRequestDialog] = useState(false)

  const handleButtonClick = () => {
    setShowRequestDialog(true)
  }

  const handleRequestCredits = (credits: string, phoneNumber: string) => {
    onRequestCredits?.(credits, phoneNumber)
    setShowRequestDialog(false)
    onClose()
  }

  const handleProceedToPayment = (credits: string, phoneNumber: string) => {
    onProceedToPayment?.(credits, phoneNumber)
    setShowRequestDialog(false)
    onClose() // Close the sheet after proceeding to payment
  }

  return (
    <>
      <Sheet
        open={open}
        trigger={trigger}
        onOpenChange={onClose}
        title="Credits"
        contentProps={{
          className: className,
          side: 'custom',
        }}
        bodyProps={{
          className: 'p-0 h-full',
        }}
        content={
          <div className="flex flex-col items-center justify-center h-full p-6">
            {/* Fixed Image - Centered */}
            <div className="flex-col items-center justify-center">
              <img
                src="https://frontend-static-files.geoiq.io/strapi/Group_8faa24a1c9/Group_8faa24a1c9.svg"
                alt="Credit information"
                className="w-[280px] h-[120px] object-contain"
              />
              <div className="mt-2 flex justify-center">
                <Typography variant="h2" className="flex items-center mb-4">
                  {credit_details}
                  <img
                    src={
                      'https://frontend-static-files.geoiq.io/strapi/Credit_Icon_e6fcaf6845/Credit_Icon_e6fcaf6845.svg'
                    }
                    width={32}
                    height={32}
                    alt="coin icon"
                    className="ml-1"
                  />
                </Typography>
                {description && (
                  <Typography variant="body1" className="text-light-3">
                    {description}
                  </Typography>
                )}
              </div>
            </div>
          </div>
        }
        footer={
          <div className="flex w-full justify-center">
            <Button
              variant="primary"
              suffixIcon={
                <img
                  src={
                    'https://frontend-static-files.geoiq.io/strapi/navbar_credits_247858e26a.svg'
                  }
                  width={16}
                  height={16}
                  alt="coin icon"
                  className="ml-1"
                />
              }
              title="Request for credits"
              onClick={handleButtonClick}
            />
          </div>
        }
        container={
          typeof document !== 'undefined'
            ? document.getElementById(containerId || '')
            : undefined
        }
      />

      {/* Request Credits Dialog */}
      <RequestCreditsDialog
        open={showRequestDialog}
        onClose={() => setShowRequestDialog(false)}
        onRequestCredits={handleRequestCredits}
        onProceedToPayment={handleProceedToPayment}
        dialogClassName={dialogClassName}
        buyCreditsOptions={buyCreditsOptions}
        minimumCreditsToBuy={minimumCreditsToBuy}
        requestOnly={requestOnly}
      />
    </>
  )
}
